"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeToken = exports.setToken = exports.triggerWidgetEvent = exports.handleDisplayUrlChange = void 0;
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var slate_react_1 = require("slate-react");
var validator_1 = require("validator");
var handleDisplayUrlChange = function (props) {
    var embedUrl = props.embedUrl, preset = props.preset;
    var validatedUrl = embedUrl;
    var updateData = {
        action: "update",
        path: slate_react_1.ReactEditor.findPath(props.widgetManager.editor, props.element),
    };
    if (embedUrl === "") {
        props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("iframe", __assign(__assign({}, updateData), { toUpdate: { embedUrl: embedUrl } })));
        return;
    }
    if (embedUrl.indexOf("//") === 0) {
        validatedUrl = embedUrl.replace("//", "https://");
    }
    else if (embedUrl.indexOf("https://") !== 0 && embedUrl.indexOf("http://") !== 0) {
        validatedUrl = "https://".concat(embedUrl);
    }
    if (!(0, validator_1.isURL)(validatedUrl)) {
        throw new Error("Invalid URL provided");
    }
    props.telemetry.iframeWidgetURLUpdated(validatedUrl, preset);
    props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("iframe", __assign(__assign({}, updateData), { toUpdate: { embedUrl: validatedUrl, embedPreset: preset.key } })));
};
exports.handleDisplayUrlChange = handleDisplayUrlChange;
var triggerWidgetEvent = function (eventData, widgetManager) {
    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("iframe", eventData));
};
exports.triggerWidgetEvent = triggerWidgetEvent;
var setToken = function (_a) {
    var widgetManager = _a.widgetManager, element = _a.element, token = _a.token;
    var updateData = {
        action: "update",
        path: widgetManager.getPath(element),
        toUpdate: {
            variable: {
                name: token.apiName,
                label: token.name,
                substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
            },
            embedUrl: "",
            embedPreset: null,
        },
    };
    (0, exports.triggerWidgetEvent)(updateData, widgetManager);
};
exports.setToken = setToken;
var removeToken = function (_a) {
    var widgetManager = _a.widgetManager, element = _a.element;
    var updateData = {
        action: "update",
        path: widgetManager.getPath(element),
        toUpdate: {
            variable: null,
        },
    };
    (0, exports.triggerWidgetEvent)(updateData, widgetManager);
};
exports.removeToken = removeToken;
